(function(angular){
	'use strict';
	
	angular
		.module('realEstateVsInflationChartModule')
		.directive('realEstateVsInflationChart', [
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			'STATIC_BASE_PATH',
			realEstateVsInflationChart
		]);
	
	function realEstateVsInflationChart(
		Highcharts,
		HIGHCHARTS_OPTIONS,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			scope: {},
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/partials/charts/real-estate-vs-inflation-chart.html',
			link: function($scope, $attrs, $elem) {
				
				var homeIndexData = [0.00, 0.02, 0.07, 0.13, 0.19, 0.14, 0.15, 0.19, 0.44, 0.65, 0.80, 1.01, 1.20, 1.53, 1.91, 2.04, 2.27, 2.20, 2.55, 2.68, 2.99, 3.18, 3.76, 4.75, 4.46, 5.04, 4.70, 4.80, 4.70, 5.09, 5.18, 5.37, 6.00, 6.15, 6.40, 6.90, 7.28, 8.04, 7.78, 9.12, 9.78, 10.83, 11.29, 10.23, 9.08, 9.54, 10.60, 9.71, 11.15,
					{
						dataLabels: {
							align: 'left',
							crop: false,
							formatter: function() {
								return '+1203%';	
							},
							enabled: true,
							style: {
								color: 'hsl(21,90%,58%)',
								fontSize: '18px',
								textShadow: 'none'
							},
							verticalAlign: 'middle'
						},
						marker: {
							enabled: true,
							symbol: 'circle'
						},
						y: 12.03
					}];
				
				var cpiData = [0.00, 0.02, 0.05, 0.09, 0.14, 0.21, 0.28, 0.32, 0.37, 0.49, 0.67, 0.78, 0.88, 1.00, 1.19, 1.49, 1.79, 2.02, 2.13, 2.27, 2.38, 2.51, 2.56, 2.71, 2.88, 3.08, 3.31, 3.43, 3.57, 3.69, 3.82, 3.95, 4.10, 4.18, 4.27, 4.41, 4.61, 4.68, 4.82, 4.94, 5.11, 5.36, 5.49, 5.77, 5.77, 5.95, 6.06, 6.26, 6.38,
					{
						dataLabels: {
							align: 'left',
							crop: false,
							formatter: function() {
								return '+650%';	
							},
							enabled: true,
							style: {
								color: 'hsl(210,10%,65%)',
								fontSize: '18px',	
								textShadow: 'none'
							},
							verticalAlign: 'middle'
						},
						marker: {
							enabled: true,
							symbol: 'circle'
						},
						y: 6.50
					}];

				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: "real-estate-vs-inflation-chart"
					},
					legend: {
						enabled: true,
						itemStyle: {
							color: '#55595e',
							fontSize: "14px",
							fontWeight: 'normal'	
						},
						padding: 0,
						reversed: true,
						symbolHeight: 12,
						symbolWidth: 12,
						symbolRadius: 6
					},
					plotOptions: {
						areaspline: {
							states: {
								hover: {
									enabled: false
								}
							}
						},
						series: {
							marker: {
								enabled: false
							}
						}
					},
					series: [
						{
							color: 'hsl(210,10%,80%)',
							data: cpiData,
							fillColor: 'transparent',
							name: 'US Consumer Price Index',
							pointIntervalUnit: 'year', 
							pointStart: Date.UTC(1965, 0, 1)
						}, {
							color: 'hsl(21,90%,58%)',
							data: homeIndexData,
							fillColor: {
								linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
								stops: [
									[0, Highcharts.Color("#F47735").setOpacity(0.25).get('rgba')],
									[1, Highcharts.Color("#F47735").setOpacity(0).get('rgba')]
								]
							},
							name: 'US Median Home Price',
							pointIntervalUnit: 'year', 
							pointStart: Date.UTC(1965, 0, 1)
						}
					],
					xAxis: [{
						gridLineColor: 'hsl(210,10%,80%)',
						gridLineWidth: 1,
						lineColor: 'transparent',
						tickColor: 'hsl(210,10%,90%)',
						tickmarkPlacement: 'on',
						type: 'datetime'
					}],
					yAxis: {
						endOnTick: false,
						gridLineColor: 'transparent',
						labels: {
							enabled: false
						},
						plotLines: [{
							color: 'hsl(210,10%,90%)',
							dashStyle: 'Dash',
							value: 0,
							width: 1	
						}],
						startOnTick: false
					},
					tooltip: {
						enabled: false
					}
				});
			}	
		};
	}
})(window.angular);